import React, { useRef } from "react";
import { Flex, FormInput, Provider } from "@fluentui/react-northstar";
import PropTypes from "prop-types";

const KEY_CODE = {
  backspace: 8,
};

const InputBoxGroup = (props) => {
  const { values, testId, onChange, onSubmit, resetInputs, hasError } = props;

  const inputRefs = useRef([]);

  const handleOnChange = (event, idx) => {
    const val = event.target.value;
    const newValues = [...values];
    newValues[idx] = val;

    // move onto next field if there is one
    if (val.length > 0 && idx + 1 < values.length) {
      inputRefs.current[idx + 1].focus();
      inputRefs.current[idx + 1].select();
    }

    onChange(newValues);

    // submit if on the last input
    if (idx === values.length - 1) {
      onSubmit(newValues);
    }
  };

  const handleOnKeyDown = (event, idx) => {
    if (event.keyCode === KEY_CODE.backspace) {
      event.preventDefault();

      const prevInput = inputRefs.current[idx - 1];
      const newValues = [...values];
      // remove character if already populated
      if (newValues[idx]) {
        newValues[idx] = "";
        onChange(newValues);
      } else if (prevInput) {
        newValues[idx - 1] = "";

        // else move focus to previous input
        prevInput.focus();
        onChange(newValues);
      }
    }
  };

  const handleOnFocus = (event) => {
    if (!hasError) return;
    resetInputs();
  };

  return (
    <Provider.Consumer
      render={(theme) => (
        <Flex
          fill
          className="input-box-group"
          space="around"
          data-testid={testId}
        >
          {values.map((value, index) => {
            return (
              <FormInput
                maxLength="1"
                id={index}
                key={index}
                autoComplete="off"
                className={
                  hasError ? "error " + theme.siteVariables.themeString : ""
                }
                data-testid={testId + "Input"}
                onChange={(event) => handleOnChange(event, index)}
                onKeyDown={(event) => handleOnKeyDown(event, index)}
                onFocus={handleOnFocus}
                value={value}
                ref={(el) => (inputRefs.current[index] = el)}
              />
            );
          })}
        </Flex>
      )}
    ></Provider.Consumer>
  );
};

InputBoxGroup.propTypes = {
  values: PropTypes.array,
  testId: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  resetInputs: PropTypes.func,
};

InputBoxGroup.defaultProps = {
  values: [],
  testId: "",
};

export default InputBoxGroup;
